import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { IoIosSearch } from 'react-icons/io';
import { MdOutlineMessage, MdArrowDropDown } from "react-icons/md";
import { IoMdNotificationsOutline } from "react-icons/io";
import profile from "../assests/images/Texpidea Logo 1.png";
import dashicon from "../assests/images/Texpidea Logo 1.png";
import SearchResult from './SearchResult';

const Header = () => {
    const [notificationCount, setNotificationCount] = useState(0);
    const [messageCount, setMessageCount] = useState(0);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    const [currentTime, setCurrentTime] = useState(new Date());
    const navigate = useNavigate()
    const currentDate = new Date();

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(intervalId);
    }, []);

    const formattedTime = currentTime.toLocaleTimeString();
    const formattedDate = currentDate.toDateString();

    const [userName, setUserName] = useState("");
    const [dropdownTitle, setDropdownTitle] = useState("");

    useEffect(() => {
        const storedName = localStorage.getItem("name");
        const userType = localStorage.getItem("userType");

        if (storedName) {
            setUserName(storedName);
        } else {
            setUserName("Unauthorized");
        }

        const handleClickOutside = (e) => {
            if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
                setIsDropdownOpen(false);
            };
        }
        document.addEventListener("mousedown", handleClickOutside);

        if (userType === "admin") {
            setDropdownTitle("Admin");
        } else if (userType === "user") {
            setDropdownTitle("User");
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("token");
        window.location.reload()
    };
    // search bar
    const [isSearchOpen, setIsSearchOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [isSearchModalOpen, setIsSearchModalOpen] = useState(false);
    const [highlightedUser, setHighlightedUser] = useState(null);

    const handleSearchToggle = () => {
        setIsSearchOpen((prev) => !prev);
    };

    const handleSearchChange = (e) => {
        setSearchTerm(e.target.value);
    };

    const handleSearchClick = () => {
        setIsSearchModalOpen(true);
    };
    const handleViewUser = (userId) => {
        setHighlightedUser(userId); // This is where you'd highlight or focus on the specific user
        setIsSearchOpen(false); // Close the search modal
    };
    return (
        <>
            <div className='h-[18vh] w-full flex flex-col '>
                <div className=" w-full h-full  flex  items-center justify-center lg:py-1 2xl:py-5">
                    <div className="w-1/3 flex items-center  justify-center  lg:pr-5 xl:pr-[110px] 2xl:pr-80 ">
                        <div
                            onClick={handleSearchClick}
                            className="search-container  w-80  lg:w-[200px] xl:w-[280px] 2xl:w-96 flex space-between items-center px-4 rounded-[15px] text-white border border-solid border-white border-opacity-60 bg-white bg-opacity-40 backdrop-blur-[5.7px] text-white 2xl:w-80">
                            <IoIosSearch className="search-icon text-2xl mr-2 lg:text-[15px] xl:text-3xl 2xl:text-4xl " />
                            <input
                                type="text"
                                className="placeholder-white bg-transparent outline-none border-none lg:w-1/2 lg:text-[15px] my-2 text-2lg 2xl:w-80 2xl:py-2 mx-3"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={handleSearchChange}

                            />

                        </div>
                    </div>
                    <SearchResult
                        isOpen={isSearchModalOpen}
                        onClose={() => setIsSearchModalOpen(false)}
                        searchTerm={searchTerm}
                        onView={handleViewUser}
                    />
                    {/* Example of how you'd use the 'highlightedUser' state */}
                    {highlightedUser && (
                        <div>
                            <h2>Highlighted User ID: {highlightedUser}</h2>
                            {/* Add logic to focus on this user */}
                        </div>
                    )}
                    <div className="w-1/3  flex items-center justify-center  text-white ">
                        <div className="flex text-4lg 2xl:text-4xl" >
                            <p>{formattedDate}, {formattedTime}</p>
                        </div>
                    </div>
                    <div className="w-1/3  flex items-center justify-center text-white pl-40 lg:pl-0 lg:pl-0 2xl:pl-38">
                        <ul className='flex items-center justify-center '>
                            <li>
                                <div className="flex items-center justify-center relative">
                                    <MdOutlineMessage
                                        className="text-3xl relative   2xl:text-7xl"
                                        onClick={() => setMessageCount(messageCount + 1)}
                                    />
                                    <div
                                        className="absolute top-[-5px] right-[-7px] w-[22px] 2xl:w-[30px] 2xl:py-3  h-[16px] flex justify-center items-center  font-semibold bg-green-500 text-white text-xs"
                                    >
                                        {messageCount}
                                    </div>
                                </div>

                            </li>
                            <div className="flex  items-center justify-center relative">

                                <div style={{ position: 'relative' }}>
                                    {/* ... notification code  */}
                                    <div style={{ position: 'relative' }}>
                                        <IoMdNotificationsOutline
                                            className='text-3xl mx-8 lg:mx-2 xl:mx-8 2xl:text-7xl'
                                            onClick={() => setNotificationCount(notificationCount + 1)}
                                        />
                                        <div className='absolute top-[-5px] right-[10px] w-[22px] lg:right-0 xl:right-6 2xl:w-[30px] 2xl:py-3 2xl:right-19 flex justify-center items-center h-[16px] font-semibold bg-red-500 text-white text-xs'>
                                            {notificationCount}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <li>
                                <div ref={dropdownRef} className="flex  items-center justify-center relative">
                                    <img src={profile} alt="logoapp" className="w-20 object-cover lg:w-16 2xl:w-24" />


                                    {/* Dropdown Button */}

                                    <p className=" flex name-pro text-1xl lg:text-[15px]  xl:text-[20px]  2xl:text-4xl cursor-pointer focus:outline-none" onClick={toggleDropdown}>{userName.length > 15 ? userName.substring(0, 12) + "..." : userName}
                                        <MdArrowDropDown className="  text-3xl  lg:text-[20px] xl:text-[35px] 2xl:text-4xl" />
                                    </p>

                                    {/* Dropdown Content */}
                                    {isDropdownOpen && (
                                        <div className="absolute top-full right-0 z-10  bg-white border rounded shadow-md p-2 2xl:px-10">
                                            {/* Dropdown Options */}
                                            <ul>
                                                <li onClick={() => {
                                                    const confirmLogout = window.confirm("Are you sure you want to sign out?");
                                                    if (confirmLogout) {
                                                        handleLogout()
                                                    }
                                                }} className="p-1 cursor-pointer text-black 2xl:text-3xl" >Log Out</li>

                                            </ul>
                                        </div>
                                    )}
                                </div>
                            </li>

                        </ul>
                    </div>
                </div>

                <div className="h-full flex items-center bg-white px-5 lg:px-10 2xl:px-20" >
                    <p className="2xl:text-4xl  pb-1 font-semi-bold" >Products :</p>
                    <div className="flex-grow flex justify-center items-start pr-16">
                        <img src={dashicon} alt="logoapp" className="w-28 lg:w-13  md:w-11 xl:w-[56px] 2xl:w-32 "
                        />
                    </div>

                </div>
            </div>

        </>
    )
}
export default Header;
